module.exports = __webpack_public_path__ + "static/media/discover.c5e8cd5e.svg";